<template>
    <div>
        <back-button :route="{ name: 'finnancial.chargebacks.users' }" />

        <div class="mb-6 bg-white p-6 shadow dark:bg-gray-800 sm:rounded-lg">
            <h3
                class="mb-4 text-lg font-medium leading-6 text-gray-900 dark:text-white"
            >
                Importar Transações
            </h3>

            <form @submit.prevent="uploadFile" class="space-y-4">
                <div>
                    <label
                        for="file_input"
                        class="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
                    >
                        Arquivo Excel (.xlsx)
                    </label>
                    <input
                        class="block w-full cursor-pointer rounded-lg border border-gray-300 bg-gray-50 text-sm text-gray-900 focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400 dark:placeholder-gray-400"
                        id="file_input"
                        type="file"
                        ref="file"
                        accept=".xlsx,.xls"
                        required
                    />
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                        O arquivo deve conter as colunas: Case Id, Account
                        Number, Transaction Date, Transaction Amount, etc.
                    </p>
                </div>

                <div class="flex items-center">
                    <input
                        id="dry-run"
                        v-model="dryRun"
                        type="checkbox"
                        class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <label
                        for="dry-run"
                        class="ml-2 block text-sm text-gray-900 dark:text-gray-100"
                    >
                        Modo simulação (dry-run) - apenas visualizar sem salvar
                        no banco
                    </label>
                </div>

                <submit-button :loading="uploading">
                    {{ dryRun ? "Simular Processamento" : "Processar Arquivo" }}
                </submit-button>
            </form>
        </div>

        <div v-if="transactions.length > 0" class="sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full sm:px-6 lg:px-8">
                <div class="mb-4 text-sm text-gray-600 dark:text-gray-400">
                    <span class="font-semibold">Resultados:</span>
                    <span class="text-green-600 dark:text-green-400"
                        >{{ foundCount }} encontradas</span
                    >,
                    <span class="text-red-600 dark:text-red-400"
                        >{{ notFoundCount }} não encontradas</span
                    >
                    <span
                        v-if="duplicatesCount > 0"
                        class="text-yellow-600 dark:text-yellow-400"
                        >, {{ duplicatesCount }} duplicadas</span
                    >
                </div>
                <div
                    class="not-prose relative rounded-xl bg-slate-50 dark:bg-slate-800/25"
                >
                    <table-component
                        :loading="loading"
                        :headers="[
                            'Case ID',
                            'Data Trans.',
                            'Valor',
                            'Cartão',
                            'Transação',
                            'Pedido',
                            'Produto',
                            'Status',
                            'Notificação',
                        ]"
                    >
                        <template
                            v-for="(item, index) in transactions"
                            :key="index"
                        >
                            <tr
                                v-if="
                                    item.found && item.transactions.length > 0
                                "
                                v-for="(
                                    transaction, tIndex
                                ) in item.transactions"
                                :key="`${index}-${tIndex}`"
                                :class="
                                    item.is_duplicate
                                        ? 'bg-yellow-50 dark:bg-yellow-900/10'
                                        : 'bg-green-50 dark:bg-green-900/10'
                                "
                            >
                                <td class="table-cell-sm">
                                    {{ item.case_id || "--" }}
                                </td>
                                <td class="table-cell-sm">
                                    <div>
                                        <span
                                            class="font-semibold text-green-600 dark:text-green-400"
                                        >
                                            {{
                                                new Date(
                                                    item.transaction_date,
                                                ).toLocaleDateString("pt-BR")
                                            }}
                                        </span>
                                        <span
                                            v-if="
                                                item.search_type ===
                                                'date_range_1_day'
                                            "
                                            class="block text-xs text-orange-500 dark:text-orange-400"
                                        >
                                            (±1 dia)
                                        </span>
                                        <span
                                            v-else-if="
                                                item.search_type ===
                                                'date_range_3_days'
                                            "
                                            class="block text-xs text-red-500 dark:text-red-400"
                                        >
                                            (±3 dias)
                                        </span>
                                    </div>
                                </td>
                                <td class="table-cell-sm">
                                    <div>
                                        <span
                                            class="font-semibold text-green-600 dark:text-green-400"
                                        >
                                            R$
                                            {{
                                                parseFloat(
                                                    item.transaction_amount ||
                                                        0,
                                                )
                                                    .toFixed(2)
                                                    .replace(".", ",")
                                            }}
                                        </span>
                                        <span
                                            v-if="transaction.installments > 1"
                                            class="block text-xs text-gray-500 dark:text-gray-400"
                                        >
                                            ({{ transaction.installments }}x de
                                            R$
                                            {{
                                                transaction.installment_value
                                                    .toFixed(2)
                                                    .replace(".", ",")
                                            }})
                                        </span>
                                    </div>
                                </td>
                                <td class="table-cell-sm">
                                    <span
                                        class="font-semibold text-green-600 dark:text-green-400"
                                    >
                                        {{ item.first_6 }}...{{ item.last_4 }}
                                    </span>
                                </td>
                                <td class="table-cell-sm">
                                    {{ transaction.hash }}
                                </td>
                                <td class="table-cell-sm">
                                    <router-link
                                        v-if="transaction.order"
                                        :to="{
                                            name: 'user.order',
                                            params: {
                                                order_id: transaction.order_id,
                                            },
                                        }"
                                        class="text-indigo-400 hover:cursor-pointer hover:text-indigo-700 hover:underline"
                                        target="_blank"
                                    >
                                        #{{ transaction.order_id }}
                                    </router-link>
                                    <span v-else>--</span>
                                </td>
                                <td class="table-cell-sm">
                                    <span v-if="transaction.order">
                                        {{
                                            transaction.order.items
                                                .map(
                                                    (item) => item.product.name,
                                                )
                                                .join(", ")
                                        }}
                                    </span>
                                    <span v-else>--</span>
                                </td>
                                <td class="table-cell-sm">
                                    <status
                                        :status="transaction.status"
                                        size="sm"
                                    />
                                </td>
                                <td class="table-cell-sm">
                                    <div class="flex items-center space-x-2">
                                        <span
                                            v-if="item.is_duplicate"
                                            class="inline-flex items-center rounded bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100"
                                        >
                                            Duplicada
                                        </span>
                                        <span
                                            v-else
                                            class="inline-flex items-center rounded bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 dark:bg-green-800 dark:text-green-100"
                                        >
                                            Nova
                                        </span>
                                        <span
                                            v-if="item.notification_id"
                                            class="text-xs text-gray-500 dark:text-gray-400"
                                        >
                                            #{{ item.notification_id }}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr
                                v-else-if="!item.found"
                                class="bg-red-50 dark:bg-red-900/10"
                            >
                                <td class="table-cell-sm">
                                    {{ item.case_id || "--" }}
                                </td>
                                <td
                                    class="table-cell-sm text-red-600 dark:text-red-400"
                                >
                                    {{
                                        new Date(
                                            item.transaction_date,
                                        ).toLocaleDateString("pt-BR")
                                    }}
                                </td>
                                <td
                                    class="table-cell-sm text-red-600 dark:text-red-400"
                                >
                                    R$
                                    {{
                                        parseFloat(item.transaction_amount || 0)
                                            .toFixed(2)
                                            .replace(".", ",")
                                    }}
                                </td>
                                <td
                                    class="table-cell-sm text-red-600 dark:text-red-400"
                                >
                                    {{ item.first_6 }}...{{ item.last_4 }}
                                </td>
                                <td
                                    class="table-cell-sm text-red-600 dark:text-red-400"
                                    colspan="4"
                                >
                                    Transação não encontrada
                                </td>
                                <td class="table-cell-sm">
                                    <div class="flex items-center space-x-2">
                                        <span
                                            v-if="item.is_duplicate"
                                            class="inline-flex items-center rounded bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100"
                                        >
                                            Duplicada
                                        </span>
                                        <span
                                            v-else
                                            class="inline-flex items-center rounded bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800 dark:bg-red-800 dark:text-red-100"
                                        >
                                            Não encontrada
                                        </span>
                                        <span
                                            v-if="item.notification_id"
                                            class="text-xs text-gray-500 dark:text-gray-400"
                                        >
                                            #{{ item.notification_id }}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </table-component>
                </div>
            </div>
        </div>

        <div
            v-else-if="processed && transactions.length === 0"
            class="border-l-4 border-yellow-400 bg-yellow-50 p-4 dark:border-yellow-600 dark:bg-yellow-900/20"
        >
            <p class="text-sm text-yellow-700 dark:text-yellow-400">
                Nenhuma transação foi encontrada com os critérios do arquivo
                importado.
            </p>
        </div>

        <!-- Seção de Notificações do Banco -->
        <div v-if="showNotifications" class="mt-8">
            <div
                class="mb-6 bg-white p-6 shadow dark:bg-gray-800 sm:rounded-lg"
            >
                <div class="mb-4 flex items-center justify-between">
                    <h3
                        class="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                    >
                        Histórico de Notificações de Chargeback
                    </h3>
                    <div class="flex items-center space-x-4">
                        <!-- View Toggle -->
                        <div
                            class="inline-flex rounded-md shadow-sm"
                            role="group"
                        >
                            <button
                                @click="tableView = 'notifications'"
                                type="button"
                                :class="[
                                    tableView === 'notifications'
                                        ? 'bg-indigo-600 text-white'
                                        : 'bg-white text-gray-700 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600',
                                    'inline-flex items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm font-medium focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600',
                                ]"
                            >
                                <svg
                                    class="mr-2 h-4 w-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                    ></path>
                                </svg>
                                Notificações
                            </button>
                            <button
                                @click="tableView = 'candidates'"
                                type="button"
                                :class="[
                                    tableView === 'candidates'
                                        ? 'bg-indigo-600 text-white'
                                        : 'bg-white text-gray-700 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600',
                                    'inline-flex items-center rounded-r-md border border-l-0 border-gray-300 px-4 py-2 text-sm font-medium focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600',
                                ]"
                            >
                                <svg
                                    class="mr-2 h-4 w-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                                    ></path>
                                </svg>
                                Candidatas
                            </button>
                        </div>

                        <button
                            @click="loadNotifications"
                            class="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                            <svg
                                class="mr-2 h-4 w-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                ></path>
                            </svg>
                            Atualizar
                        </button>
                    </div>
                </div>

                <!-- Notifications View (Current) -->
                <table-component
                    v-if="tableView === 'notifications'"
                    :loading="loadingNotifications"
                    :headers="[
                        'ID',
                        'Fonte',
                        'Case ID',
                        'Data Trans.',
                        'Valor',
                        'Cartão',
                        'Parcela',
                        'Venda',
                        'Status',
                        'Transação',
                        'Confiança',
                        'Processado em',
                        'Ações',
                    ]"
                    :pagination="notificationsPagination"
                    @fetch="loadNotifications"
                >
                    <tr
                        v-for="notification in notifications"
                        :key="notification.id"
                        :class="{
                            'bg-green-50 dark:bg-green-900/10':
                                notification.status === 'processed',
                            'bg-red-50 dark:bg-red-900/10':
                                notification.status === 'not_found',
                            'bg-yellow-50 dark:bg-yellow-900/10':
                                notification.status === 'error',
                            'bg-gray-50 dark:bg-gray-900/10':
                                notification.status === 'pending',
                            'bg-blue-50 dark:bg-blue-900/10':
                                notification.status === 'pending_review',
                        }"
                    >
                        <td class="table-cell-sm">#{{ notification.id }}</td>
                        <td class="table-cell-sm">
                            <span
                                class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"
                                :class="{
                                    'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100':
                                        notification.source === 'visa_webhook',
                                    'bg-purple-100 text-purple-800 dark:bg-purple-800 dark:text-purple-100':
                                        notification.source === 'excel_import',
                                }"
                            >
                                {{
                                    notification.source === "visa_webhook"
                                        ? "Visa Webhook"
                                        : "Excel Import"
                                }}
                            </span>
                        </td>
                        <td class="table-cell-sm">
                            {{ notification.case_id }}
                        </td>
                        <td class="table-cell-sm">
                            <span
                                class="inline-flex items-center rounded bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800 dark:bg-blue-800 dark:text-blue-100"
                            >
                                {{
                                    notification.transaction_date
                                        ? new Date(
                                              notification.transaction_date,
                                          ).toLocaleDateString("pt-BR")
                                        : "--"
                                }}
                            </span>
                        </td>
                        <td class="table-cell-sm">
                            <span
                                class="inline-flex items-center rounded bg-orange-100 px-2 py-0.5 text-xs font-medium text-orange-800 dark:bg-orange-800 dark:text-orange-100"
                            >
                                R$
                                {{
                                    parseFloat(
                                        notification.transaction_amount || 0,
                                    )
                                        .toFixed(2)
                                        .replace(".", ",")
                                }}
                            </span>
                        </td>
                        <td class="table-cell-sm">
                            <span
                                class="inline-flex items-center rounded bg-indigo-100 px-2 py-0.5 text-xs font-medium text-indigo-800 dark:bg-indigo-800 dark:text-indigo-100"
                            >
                                {{ notification.card_first_6 || ""
                                }}{{
                                    notification.card_first_6 &&
                                    notification.card_last_4
                                        ? "..."
                                        : ""
                                }}{{ notification.card_last_4 || "" }}
                            </span>
                        </td>
                        <td class="table-cell-sm">
                            {{ notification.installment_number }}/{{
                                notification.total_installments
                            }}
                        </td>
                        <td class="table-cell-sm">
                            <router-link
                                v-if="notification.order_id"
                                :to="{
                                    name: 'user.order',
                                    params: {
                                        order_id: notification.order_id,
                                    },
                                }"
                                class="text-indigo-400 hover:cursor-pointer hover:text-indigo-700 hover:underline"
                                target="_blank"
                            >
                                #{{ notification.order_id }}
                            </router-link>
                            <span v-else>--</span>
                        </td>
                        <td class="table-cell-sm">
                            <span
                                class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"
                                :class="{
                                    'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100':
                                        notification.status === 'processed',
                                    'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100':
                                        notification.status === 'not_found',
                                    'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100':
                                        notification.status === 'error',
                                    'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100':
                                        notification.status === 'pending',
                                    'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100':
                                        notification.status ===
                                        'pending_review',
                                }"
                            >
                                {{
                                    notification.status === "pending_review"
                                        ? "Revisão"
                                        : notification.status === "processed"
                                          ? "Processado"
                                          : notification.status === "not_found"
                                            ? "Não encontrado"
                                            : notification.status
                                }}
                            </span>
                        </td>
                        <td class="table-cell-sm">
                            <div v-if="notification.transaction_id">
                                <span
                                    v-if="notification.has_pre_selection"
                                    class="text-xs text-blue-600 dark:text-blue-400"
                                >
                                    Pré-selecionada:
                                </span>
                                <span
                                    v-else-if="notification.is_confirmed"
                                    class="text-xs text-green-600 dark:text-green-400"
                                >
                                    Confirmada:
                                </span>
                                <span class="text-xs">
                                    #{{ notification.transaction_id }}
                                </span>
                            </div>
                            <span v-else class="text-xs text-gray-500">--</span>
                        </td>
                        <td class="table-cell-sm">
                            <span
                                v-if="notification.match_confidence"
                                class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"
                                :class="{
                                    'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100':
                                        notification.match_confidence ===
                                        'high',
                                    'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100':
                                        notification.match_confidence ===
                                        'medium',
                                    'bg-orange-100 text-orange-800 dark:bg-orange-800 dark:text-orange-100':
                                        notification.match_confidence === 'low',
                                    'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100':
                                        notification.match_confidence ===
                                        'manual_review',
                                }"
                            >
                                {{
                                    notification.match_confidence === "high"
                                        ? "Alta"
                                        : notification.match_confidence ===
                                            "medium"
                                          ? "Média"
                                          : notification.match_confidence ===
                                              "low"
                                            ? "Baixa"
                                            : "Manual"
                                }}
                            </span>
                            <span v-else class="text-xs text-gray-500">--</span>
                        </td>
                        <td class="table-cell-sm">
                            {{
                                notification.processed_at
                                    ? new Date(
                                          notification.processed_at,
                                      ).toLocaleString("pt-BR")
                                    : "--"
                            }}
                        </td>
                        <td class="table-cell-sm">
                            <div class="flex items-center space-x-2">
                                <!-- Botão Revisar para pending_review ou pré-seleção não confirmada -->
                                <button
                                    v-if="
                                        notification.status ===
                                            'pending_review' ||
                                        notification.requires_review ||
                                        (notification.has_pre_selection &&
                                            !notification.is_confirmed)
                                    "
                                    @click="reviewNotification(notification)"
                                    class="inline-flex items-center rounded border border-transparent bg-blue-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    <svg
                                        class="mr-1 h-3 w-3"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                                        ></path>
                                    </svg>
                                    Revisar
                                </button>

                                <!-- Botão Ver Candidatos (sempre visível quando há candidatos) -->
                                <button
                                    v-if="notification.candidate_count > 0"
                                    @click="viewCandidates(notification)"
                                    class="inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                                >
                                    <svg
                                        class="mr-1 h-3 w-3"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        ></path>
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                        ></path>
                                    </svg>
                                    {{ notification.candidate_count }}
                                    {{
                                        notification.candidate_count === 1
                                            ? "candidata"
                                            : "candidatas"
                                    }}
                                </button>

                                <button
                                    v-if="
                                        notification.status === 'not_found' ||
                                        notification.status === 'error'
                                    "
                                    @click="forceSearch(notification)"
                                    :disabled="
                                        processingNotification ===
                                        notification.id
                                    "
                                    class="inline-flex items-center rounded border border-transparent bg-cyan-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    <svg
                                        class="mr-1 h-3 w-3"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                        ></path>
                                    </svg>
                                    Re-buscar
                                </button>

                                <!-- Botão Processar para pending (inicial) -->
                                <button
                                    v-if="
                                        notification.status === 'pending' &&
                                        !notification.has_pre_selection &&
                                        !notification.requires_review
                                    "
                                    @click="processNotification(notification)"
                                    :disabled="
                                        processingNotification ===
                                        notification.id
                                    "
                                    class="inline-flex items-center rounded border border-transparent bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    <svg
                                        v-if="
                                            processingNotification ===
                                            notification.id
                                        "
                                        class="-ml-0.5 mr-1.5 h-3 w-3 animate-spin text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        ></circle>
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    <svg
                                        v-else
                                        class="mr-1 h-3 w-3"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                        ></path>
                                    </svg>
                                    {{
                                        processingNotification ===
                                        notification.id
                                            ? "Processando..."
                                            : "Processar"
                                    }}
                                </button>

                                <!-- Botão Reprocessar para erros ou não encontradas -->
                                <button
                                    v-if="
                                        notification.status === 'not_found' ||
                                        notification.status === 'error'
                                    "
                                    @click="processNotification(notification)"
                                    :disabled="
                                        processingNotification ===
                                        notification.id
                                    "
                                    class="inline-flex items-center rounded border border-transparent bg-orange-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                >
                                    <svg
                                        v-if="
                                            processingNotification ===
                                            notification.id
                                        "
                                        class="-ml-0.5 mr-1.5 h-3 w-3 animate-spin text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        ></circle>
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    <svg
                                        v-else
                                        class="mr-1 h-3 w-3"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                        ></path>
                                    </svg>
                                    {{
                                        processingNotification ===
                                        notification.id
                                            ? "Processando..."
                                            : "Reprocessar"
                                    }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </table-component>

                <!-- Candidates View (New) -->
                <table-component
                    v-if="tableView === 'candidates'"
                    :loading="loadingNotifications"
                    :headers="[
                        '',
                        'Case ID',
                        'Data',
                        'Valor',
                        'Cartão',
                        'Status',
                        'Confiança',
                        'Candidatas',
                        'Ações',
                    ]"
                    :pagination="notificationsPagination"
                    @fetch="loadNotifications"
                >
                    <template
                        v-for="notification in notifications"
                        :key="notification.id"
                    >
                        <!-- Main notification row -->
                        <tr
                            :class="{
                                'bg-green-50 dark:bg-green-900/10':
                                    notification.status === 'processed',
                                'bg-red-50 dark:bg-red-900/10':
                                    notification.status === 'not_found',
                                'bg-yellow-50 dark:bg-yellow-900/10':
                                    notification.status === 'error',
                                'bg-gray-50 dark:bg-gray-900/10':
                                    notification.status === 'pending',
                                'bg-blue-50 dark:bg-blue-900/10':
                                    notification.status === 'pending_review',
                            }"
                        >
                            <td class="table-cell-sm">
                                <button
                                    v-if="
                                        notification.candidate_count > 0 ||
                                        notification.status === 'pending_review'
                                    "
                                    @click="
                                        toggleNotificationExpansion(
                                            notification,
                                        )
                                    "
                                    class="rounded p-1 hover:bg-gray-200 dark:hover:bg-gray-700"
                                    :disabled="
                                        loadingCandidates.has(notification.id)
                                    "
                                >
                                    <svg
                                        v-if="
                                            loadingCandidates.has(
                                                notification.id,
                                            )
                                        "
                                        class="h-4 w-4 animate-spin text-gray-500"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        ></circle>
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    <svg
                                        v-else
                                        :class="[
                                            'h-4 w-4 transition-transform',
                                            expandedNotifications.has(
                                                notification.id,
                                            )
                                                ? 'rotate-90'
                                                : '',
                                        ]"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 5l7 7-7 7"
                                        ></path>
                                    </svg>
                                </button>
                            </td>
                            <td class="table-cell-sm font-medium">
                                {{ notification.case_id }}
                            </td>
                            <td class="table-cell-sm">
                                {{
                                    notification.transaction_date
                                        ? new Date(
                                              notification.transaction_date,
                                          ).toLocaleDateString("pt-BR")
                                        : "--"
                                }}
                            </td>
                            <td class="table-cell-sm">
                                R$
                                {{
                                    parseFloat(
                                        notification.transaction_amount || 0,
                                    )
                                        .toFixed(2)
                                        .replace(".", ",")
                                }}
                            </td>
                            <td class="table-cell-sm">
                                {{ notification.card_first_6 || ""
                                }}{{
                                    notification.card_first_6 &&
                                    notification.card_last_4
                                        ? "..."
                                        : ""
                                }}{{ notification.card_last_4 || "" }}
                            </td>
                            <td class="table-cell-sm">
                                <span
                                    class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"
                                    :class="{
                                        'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100':
                                            notification.status === 'processed',
                                        'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100':
                                            notification.status === 'not_found',
                                        'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100':
                                            notification.status === 'error',
                                        'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100':
                                            notification.status === 'pending',
                                        'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100':
                                            notification.status ===
                                            'pending_review',
                                    }"
                                >
                                    {{
                                        notification.status === "pending_review"
                                            ? "Revisão"
                                            : notification.status ===
                                                "processed"
                                              ? "Processado"
                                              : notification.status ===
                                                  "not_found"
                                                ? "Não encontrado"
                                                : notification.status
                                    }}
                                </span>
                            </td>
                            <td class="table-cell-sm">
                                <span
                                    v-if="notification.match_confidence"
                                    class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"
                                    :class="{
                                        'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100':
                                            notification.match_confidence ===
                                            'high',
                                        'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100':
                                            notification.match_confidence ===
                                            'medium',
                                        'bg-orange-100 text-orange-800 dark:bg-orange-800 dark:text-orange-100':
                                            notification.match_confidence ===
                                            'low',
                                        'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100':
                                            notification.match_confidence ===
                                            'manual_review',
                                    }"
                                >
                                    {{
                                        notification.match_confidence === "high"
                                            ? "Alta"
                                            : notification.match_confidence ===
                                                "medium"
                                              ? "Média"
                                              : notification.match_confidence ===
                                                  "low"
                                                ? "Baixa"
                                                : "Manual"
                                    }}
                                </span>
                                <span v-else class="text-xs text-gray-500"
                                    >--</span
                                >
                            </td>
                            <td class="table-cell-sm">
                                <span
                                    class="inline-flex items-center rounded bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-800 dark:bg-gray-800 dark:text-gray-100"
                                >
                                    {{ notification.candidate_count || 0 }}
                                </span>
                            </td>
                            <td class="table-cell-sm">
                                <div class="flex items-center space-x-2">
                                    <button
                                        v-if="
                                            notification.status ===
                                                'pending_review' ||
                                            notification.requires_review ||
                                            (notification.has_pre_selection &&
                                                !notification.is_confirmed)
                                        "
                                        @click="
                                            reviewNotification(notification)
                                        "
                                        class="inline-flex items-center rounded border border-transparent bg-blue-600 px-2.5 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >
                                        Revisar
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <!-- Expanded candidates row -->
                        <tr
                            v-if="
                                expandedNotifications.has(notification.id) &&
                                notificationCandidates.has(notification.id)
                            "
                        >
                            <td colspan="9" class="p-0">
                                <div
                                    class="bg-gray-50 p-4 dark:bg-gray-900 dark:text-white"
                                >
                                    <div
                                        class="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300"
                                    >
                                        Transações Candidatas para
                                        {{ notification.case_id }}
                                    </div>
                                    <table
                                        class="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
                                    >
                                        <thead
                                            class="bg-gray-100 dark:bg-gray-800"
                                        >
                                            <tr>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    ID
                                                </th>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    Pedido
                                                </th>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    Valor
                                                </th>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    Parcelas
                                                </th>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    Data
                                                </th>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    Status
                                                </th>
                                                <th
                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                >
                                                    Outras Notificações
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody
                                            class="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-800"
                                        >
                                            <tr
                                                v-for="candidate in notificationCandidates.get(
                                                    notification.id,
                                                ).candidates"
                                                :key="candidate.id"
                                                :class="{
                                                    'bg-blue-50 dark:bg-blue-900/20':
                                                        candidate.id ===
                                                        notificationCandidates.get(
                                                            notification.id,
                                                        )
                                                            .pre_selected_transaction_id,
                                                    'bg-yellow-50 dark:bg-yellow-900/20':
                                                        candidate.related_notifications &&
                                                        candidate
                                                            .related_notifications
                                                            .length > 0,
                                                }"
                                            >
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    #{{ candidate.id }}
                                                    <span
                                                        v-if="
                                                            candidate.id ===
                                                            notificationCandidates.get(
                                                                notification.id,
                                                            )
                                                                .pre_selected_transaction_id
                                                        "
                                                        class="ml-2 inline-flex items-center rounded bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800 dark:bg-blue-800 dark:text-blue-100"
                                                    >
                                                        Pré-selecionada
                                                    </span>
                                                </td>
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    <router-link
                                                        v-if="
                                                            candidate.order_id
                                                        "
                                                        :to="{
                                                            name: 'user.order',
                                                            params: {
                                                                order_id:
                                                                    candidate.order_id,
                                                            },
                                                        }"
                                                        class="text-indigo-400 hover:cursor-pointer hover:text-indigo-700 hover:underline"
                                                        target="_blank"
                                                    >
                                                        #{{
                                                            candidate.order_id
                                                        }}
                                                    </router-link>
                                                    <span v-else>--</span>
                                                </td>
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    R$
                                                    {{
                                                        candidate.amount
                                                            .toFixed(2)
                                                            .replace(".", ",")
                                                    }}
                                                </td>
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    <span
                                                        v-if="
                                                            candidate.installments >
                                                            1
                                                        "
                                                    >
                                                        {{
                                                            candidate.installments
                                                        }}x de R$
                                                        {{
                                                            candidate.installment_value
                                                                .toFixed(2)
                                                                .replace(
                                                                    ".",
                                                                    ",",
                                                                )
                                                        }}
                                                    </span>
                                                    <span v-else>À vista</span>
                                                </td>
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    {{
                                                        new Date(
                                                            candidate.created_at,
                                                        ).toLocaleDateString(
                                                            "pt-BR",
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    <status
                                                        :status="
                                                            candidate.status
                                                        "
                                                        size="sm"
                                                    />
                                                </td>
                                                <td
                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                >
                                                    <div
                                                        v-if="
                                                            candidate.related_notifications &&
                                                            candidate
                                                                .related_notifications
                                                                .length > 0
                                                        "
                                                    >
                                                        <span
                                                            class="inline-flex items-center rounded bg-yellow-100 px-2 py-0.5 text-xs font-medium text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100"
                                                        >
                                                            {{
                                                                candidate
                                                                    .related_notifications
                                                                    .length
                                                            }}
                                                            notificação(ões)
                                                        </span>
                                                        <div
                                                            class="mt-1 text-xs text-gray-500 dark:text-gray-400"
                                                        >
                                                            <div
                                                                v-for="related in candidate.related_notifications.slice(
                                                                    0,
                                                                    2,
                                                                )"
                                                                :key="
                                                                    related.id
                                                                "
                                                            >
                                                                Case:
                                                                {{
                                                                    related.case_id
                                                                }}
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    candidate
                                                                        .related_notifications
                                                                        .length >
                                                                    2
                                                                "
                                                                class="text-gray-400"
                                                            >
                                                                +{{
                                                                    candidate
                                                                        .related_notifications
                                                                        .length -
                                                                    2
                                                                }}
                                                                mais...
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span
                                                        v-else
                                                        class="text-xs text-gray-500"
                                                        >Nenhuma</span
                                                    >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </template>
                </table-component>
            </div>
        </div>

        <!-- Modal de Revisão/Candidatos -->
        <TransitionRoot as="template" :show="showReviewModal">
            <Dialog
                as="div"
                class="relative z-50"
                @close="showReviewModal = false"
            >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <div
                        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    />
                </TransitionChild>

                <div class="fixed inset-0 z-10 overflow-y-auto">
                    <div
                        class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
                    >
                        <TransitionChild
                            as="template"
                            enter="ease-out duration-300"
                            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enter-to="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leave-from="opacity-100 translate-y-0 sm:scale-100"
                            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <DialogPanel
                                class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all dark:bg-gray-800 dark:text-white sm:my-8 sm:w-full sm:max-w-4xl"
                            >
                                <div
                                    class="bg-white px-4 pb-4 pt-5 dark:bg-gray-800 sm:p-6 sm:pb-4"
                                >
                                    <div class="sm:flex sm:items-start">
                                        <div class="mt-3 w-full sm:mt-0">
                                            <DialogTitle
                                                as="h3"
                                                class="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                                            >
                                                {{
                                                    reviewMode === "review"
                                                        ? "Revisar Notificação de Chargeback"
                                                        : "Candidatos para Chargeback"
                                                }}
                                            </DialogTitle>

                                            <!-- Informações da Notificação -->
                                            <div
                                                v-if="selectedNotification"
                                                class="mt-4 rounded-lg bg-gray-50 p-4 dark:bg-gray-700"
                                            >
                                                <div
                                                    class="grid grid-cols-2 gap-4 text-sm"
                                                >
                                                    <div>
                                                        <span
                                                            class="font-medium text-gray-700 dark:text-gray-300"
                                                            >Case ID:</span
                                                        >
                                                        {{
                                                            selectedNotification.case_id
                                                        }}
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-medium text-gray-700 dark:text-gray-300"
                                                            >Data:</span
                                                        >
                                                        {{
                                                            new Date(
                                                                selectedNotification.transaction_date,
                                                            ).toLocaleDateString(
                                                                "pt-BR",
                                                            )
                                                        }}
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-medium text-gray-700 dark:text-gray-300"
                                                            >Valor:</span
                                                        >
                                                        R$
                                                        {{
                                                            parseFloat(
                                                                selectedNotification.transaction_amount ||
                                                                    0,
                                                            )
                                                                .toFixed(2)
                                                                .replace(
                                                                    ".",
                                                                    ",",
                                                                )
                                                        }}
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-medium text-gray-700 dark:text-gray-300"
                                                            >Cartão:</span
                                                        >
                                                        {{
                                                            selectedNotification.card_first_6
                                                        }}...{{
                                                            selectedNotification.card_last_4
                                                        }}
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-medium text-gray-700 dark:text-gray-300"
                                                            >Confiança:</span
                                                        >
                                                        <span
                                                            class="ml-1 inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    candidatesData?.confidence ===
                                                                    'high',
                                                                'bg-yellow-100 text-yellow-800':
                                                                    candidatesData?.confidence ===
                                                                    'medium',
                                                                'bg-orange-100 text-orange-800':
                                                                    candidatesData?.confidence ===
                                                                    'low',
                                                                'bg-red-100 text-red-800':
                                                                    candidatesData?.confidence ===
                                                                    'manual_review',
                                                            }"
                                                        >
                                                            {{
                                                                candidatesData?.confidence ===
                                                                "high"
                                                                    ? "Alta"
                                                                    : candidatesData?.confidence ===
                                                                        "medium"
                                                                      ? "Média"
                                                                      : candidatesData?.confidence ===
                                                                          "low"
                                                                        ? "Baixa"
                                                                        : "Manual"
                                                            }}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span
                                                            class="font-medium text-gray-700 dark:text-gray-300"
                                                            >Critérios:</span
                                                        >
                                                        {{
                                                            candidatesData?.search_criteria
                                                                ? Object.entries(
                                                                      candidatesData.search_criteria,
                                                                  )
                                                                      .map(
                                                                          ([
                                                                              k,
                                                                              v,
                                                                          ]) =>
                                                                              `${k}: ${v}`,
                                                                      )
                                                                      .join(
                                                                          ", ",
                                                                      )
                                                                : "--"
                                                        }}
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Sem candidatos - botão para buscar -->
                                            <div
                                                v-if="
                                                    !candidatesData?.candidates ||
                                                    candidatesData.candidates
                                                        .length === 0
                                                "
                                                class="mt-4 rounded-lg border-2 border-dashed border-gray-300 p-6 text-center"
                                            >
                                                <svg
                                                    class="mx-auto h-12 w-12 text-gray-400"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                    ></path>
                                                </svg>
                                                <p
                                                    class="mt-2 text-sm text-gray-600 dark:text-gray-400"
                                                >
                                                    Nenhuma candidata armazenada
                                                    para esta notificação
                                                </p>
                                                <button
                                                    @click="searchCandidates"
                                                    :disabled="
                                                        searchingCandidates
                                                    "
                                                    class="mt-4 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                                >
                                                    <svg
                                                        v-if="
                                                            searchingCandidates
                                                        "
                                                        class="-ml-1 mr-2 h-4 w-4 animate-spin text-white"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <circle
                                                            class="opacity-25"
                                                            cx="12"
                                                            cy="12"
                                                            r="10"
                                                            stroke="currentColor"
                                                            stroke-width="4"
                                                        ></circle>
                                                        <path
                                                            class="opacity-75"
                                                            fill="currentColor"
                                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                        ></path>
                                                    </svg>
                                                    <svg
                                                        v-else
                                                        class="-ml-1 mr-2 h-4 w-4"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                                        ></path>
                                                    </svg>
                                                    {{
                                                        searchingCandidates
                                                            ? "Buscando..."
                                                            : "Buscar Candidatas"
                                                    }}
                                                </button>
                                            </div>

                                            <!-- Lista de Candidatos -->
                                            <div
                                                v-if="
                                                    candidatesData?.candidates &&
                                                    candidatesData.candidates
                                                        .length > 0
                                                "
                                                class="mt-4"
                                            >
                                                <div
                                                    class="mb-2 flex items-center justify-between"
                                                >
                                                    <h4
                                                        class="text-sm font-medium text-gray-900 dark:text-white"
                                                    >
                                                        Transações Candidatas
                                                        <span
                                                            v-if="
                                                                candidatesData.pre_selected_transaction_id
                                                            "
                                                            class="ml-2 text-xs text-blue-600 dark:text-blue-400"
                                                        >
                                                            (Pré-selecionada:
                                                            #{{
                                                                candidatesData.pre_selected_transaction_id
                                                            }})
                                                        </span>
                                                    </h4>
                                                    <div class="flex space-x-2">
                                                        <!-- Botão Regenerar Matches no Modal -->
                                                        <button
                                                            @click="
                                                                regenerateMatchesInModal
                                                            "
                                                            :disabled="
                                                                regeneratingInModal
                                                            "
                                                            class="inline-flex items-center rounded border border-transparent bg-purple-600 px-3 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                                            title="Regenerar lista de candidatos com campos atualizados"
                                                        >
                                                            <svg
                                                                v-if="
                                                                    regeneratingInModal
                                                                "
                                                                class="-ml-0.5 mr-1 h-3 w-3 animate-spin text-white"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <circle
                                                                    class="opacity-25"
                                                                    cx="12"
                                                                    cy="12"
                                                                    r="10"
                                                                    stroke="currentColor"
                                                                    stroke-width="4"
                                                                ></circle>
                                                                <path
                                                                    class="opacity-75"
                                                                    fill="currentColor"
                                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                ></path>
                                                            </svg>
                                                            <svg
                                                                v-else
                                                                class="mr-1 h-3 w-3"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                                                ></path>
                                                            </svg>
                                                            {{
                                                                regeneratingInModal
                                                                    ? "Regenerando..."
                                                                    : "Regenerar"
                                                            }}
                                                        </button>

                                                        <!-- Botão Limpar Matches no Modal -->
                                                        <button
                                                            @click="
                                                                clearMatchesInModal
                                                            "
                                                            :disabled="
                                                                clearingInModal
                                                            "
                                                            class="inline-flex items-center rounded border border-transparent bg-gray-600 px-3 py-1.5 text-xs font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                                                            title="Limpar lista de candidatos"
                                                        >
                                                            <svg
                                                                v-if="
                                                                    clearingInModal
                                                                "
                                                                class="-ml-0.5 mr-1 h-3 w-3 animate-spin text-white"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <circle
                                                                    class="opacity-25"
                                                                    cx="12"
                                                                    cy="12"
                                                                    r="10"
                                                                    stroke="currentColor"
                                                                    stroke-width="4"
                                                                ></circle>
                                                                <path
                                                                    class="opacity-75"
                                                                    fill="currentColor"
                                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                ></path>
                                                            </svg>
                                                            <svg
                                                                v-else
                                                                class="mr-1 h-3 w-3"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                ></path>
                                                            </svg>
                                                            {{
                                                                clearingInModal
                                                                    ? "Limpando..."
                                                                    : "Limpar"
                                                            }}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div
                                                    class="max-h-96 overflow-y-auto"
                                                >
                                                    <table
                                                        class="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
                                                    >
                                                        <thead
                                                            class="bg-gray-50 dark:bg-gray-700"
                                                        >
                                                            <tr>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    ID
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Pedido
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Valor
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Parcelas
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Data
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Cartão
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Bandeira
                                                                </th>
                                                                <th
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Status
                                                                </th>
                                                                <th
                                                                    v-if="
                                                                        reviewMode ===
                                                                        'review'
                                                                    "
                                                                    class="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-300"
                                                                >
                                                                    Ação
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            class="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-gray-800"
                                                        >
                                                            <tr
                                                                v-for="candidate in candidatesData.candidates"
                                                                :key="
                                                                    candidate.id
                                                                "
                                                                :class="{
                                                                    'bg-blue-50 dark:bg-blue-900/20':
                                                                        candidate.id ===
                                                                        candidatesData.pre_selected_transaction_id,
                                                                    'bg-green-50 ring-2 ring-green-500 ring-opacity-50 dark:bg-green-900/20':
                                                                        isWithinTolerance(
                                                                            candidate.installment_value,
                                                                            selectedNotification.transaction_amount,
                                                                        ) &&
                                                                        candidate.id !==
                                                                            candidatesData.pre_selected_transaction_id,
                                                                }"
                                                            >
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    #{{
                                                                        candidate.id
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    <router-link
                                                                        v-if="
                                                                            candidate.order_id
                                                                        "
                                                                        :to="{
                                                                            name: 'user.order',
                                                                            params: {
                                                                                order_id:
                                                                                    candidate.order_id,
                                                                            },
                                                                        }"
                                                                        class="text-indigo-400 hover:cursor-pointer hover:text-indigo-700 hover:underline"
                                                                        target="_blank"
                                                                    >
                                                                        #{{
                                                                            candidate.order_id
                                                                        }}
                                                                    </router-link>
                                                                    <span v-else
                                                                        >--</span
                                                                    >
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    R$
                                                                    {{
                                                                        candidate.amount
                                                                            .toFixed(
                                                                                2,
                                                                            )
                                                                            .replace(
                                                                                ".",
                                                                                ",",
                                                                            )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            candidate.installments >
                                                                            1
                                                                        "
                                                                    >
                                                                        {{
                                                                            candidate.installments
                                                                        }}x de
                                                                        R$
                                                                        {{
                                                                            candidate.installment_value
                                                                                .toFixed(
                                                                                    2,
                                                                                )
                                                                                .replace(
                                                                                    ".",
                                                                                    ",",
                                                                                )
                                                                        }}
                                                                        <span
                                                                            v-if="
                                                                                isWithinTolerance(
                                                                                    candidate.installment_value,
                                                                                    selectedNotification.transaction_amount,
                                                                                )
                                                                            "
                                                                            class="ml-1 inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 dark:bg-green-800 dark:text-green-100"
                                                                            title="Valor da parcela dentro da tolerância"
                                                                        >
                                                                            ✓
                                                                        </span>
                                                                    </span>
                                                                    <span v-else
                                                                        >1x</span
                                                                    >
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    {{
                                                                        new Date(
                                                                            candidate.created_at,
                                                                        ).toLocaleDateString(
                                                                            "pt-BR",
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    {{
                                                                        candidate.card_first_6
                                                                    }}...{{
                                                                        candidate.card_last_4
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    {{
                                                                        candidate.card_brand
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    <status
                                                                        :status="
                                                                            candidate.status
                                                                        "
                                                                        size="sm"
                                                                    />
                                                                </td>
                                                                <td
                                                                    v-if="
                                                                        reviewMode ===
                                                                        'review'
                                                                    "
                                                                    class="whitespace-nowrap px-3 py-2 text-sm"
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        :name="`candidate-${selectedNotification.id}`"
                                                                        :value="
                                                                            candidate.id
                                                                        "
                                                                        v-model="
                                                                            selectedTransactionId
                                                                        "
                                                                        class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <!-- Campo de rejeição -->
                                            <div
                                                v-if="
                                                    reviewMode === 'review' &&
                                                    showRejectReason
                                                "
                                                class="mt-4"
                                            >
                                                <label
                                                    class="block text-sm font-medium text-gray-700 dark:text-gray-300"
                                                >
                                                    Motivo da rejeição
                                                </label>
                                                <textarea
                                                    v-model="rejectReason"
                                                    rows="3"
                                                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white sm:text-sm"
                                                    placeholder="Explique por que nenhuma transação corresponde..."
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="bg-gray-50 px-4 py-3 dark:bg-gray-700 sm:flex sm:flex-row-reverse sm:px-6"
                                >
                                    <div v-if="reviewMode === 'review'">
                                        <button
                                            v-if="
                                                candidatesData?.pre_selected_transaction_id &&
                                                !showRejectReason
                                            "
                                            @click="confirmPreSelection"
                                            :disabled="reviewing"
                                            class="inline-flex w-full justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto sm:text-sm"
                                        >
                                            Confirmar Pré-seleção
                                        </button>
                                        <button
                                            v-if="
                                                selectedTransactionId &&
                                                selectedTransactionId !==
                                                    candidatesData?.pre_selected_transaction_id &&
                                                !showRejectReason
                                            "
                                            @click="changeSelection"
                                            :disabled="reviewing"
                                            class="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto sm:text-sm"
                                        >
                                            Alterar para Selecionada
                                        </button>
                                        <button
                                            v-if="showRejectReason"
                                            @click="rejectNotification"
                                            :disabled="
                                                reviewing || !rejectReason
                                            "
                                            class="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto sm:text-sm"
                                        >
                                            Confirmar Rejeição
                                        </button>
                                        <button
                                            v-if="!showRejectReason"
                                            @click="showRejectReason = true"
                                            class="mt-3 inline-flex w-full justify-center rounded-md border border-red-300 bg-white px-4 py-2 text-base font-medium text-red-700 shadow-sm hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                                        >
                                            Rejeitar Todas
                                        </button>
                                    </div>
                                    <button
                                        @click="closeModal"
                                        class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
                                    >
                                        {{
                                            reviewMode === "review"
                                                ? "Cancelar"
                                                : "Fechar"
                                        }}
                                    </button>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </TransitionRoot>
    </div>
</template>

<script>
import BackButton from "../../../../components/layouts/navigation/BackButton.vue";
import TableComponent from "../../../../components/layouts/table/TableComponent.vue";
import SubmitButton from "../../../../components/forms/SubmitButton.vue";
import Status from "../../../../components/layouts/Status.vue";
import { useToast } from "vue-toastification";
import {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";

export default {
    components: {
        BackButton,
        TableComponent,
        SubmitButton,
        Status,
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    },

    data() {
        return {
            uploading: false,
            loading: false,
            processed: false,
            transactions: [],
            foundCount: 0,
            notFoundCount: 0,
            duplicatesCount: 0,
            dryRun: false,
            // Notificações do banco
            showNotifications: true,
            loadingNotifications: false,
            notifications: [],
            notificationsPagination: null,
            processingNotification: null,
            // Modal de revisão
            showReviewModal: false,
            reviewMode: "view", // 'view' ou 'review'
            selectedNotification: null,
            candidatesData: null,
            selectedTransactionId: null,
            showRejectReason: false,
            rejectReason: "",
            reviewing: false,
            searchingCandidates: false,
            regeneratingInModal: false,
            clearingInModal: false,
            // View toggle
            tableView: "notifications", // 'notifications' or 'candidates'
            expandedNotifications: new Set(),
            notificationCandidates: new Map(),
            loadingCandidates: new Set(),
        };
    },

    setup() {
        const toast = useToast();
        return { toast };
    },

    watch: {
        tableView(newView) {
            // Clear expanded notifications when switching views
            if (newView === "notifications") {
                this.expandedNotifications.clear();
                this.expandedNotifications = new Set();
            }
        },
    },

    mounted() {
        this.loadNotifications();
    },

    methods: {
        async uploadFile() {
            if (!this.$refs.file.files[0]) {
                this.toast.error("Por favor, selecione um arquivo");
                return;
            }

            this.uploading = true;
            this.processed = false;

            try {
                const file = this.$refs.file.files[0];
                const formData = new FormData();
                formData.append("file", file);
                formData.append("dry_run", this.dryRun ? "1" : "0");

                const { data } = await axios.post(
                    "/api/global-chargebacks/upload",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.transactions = data.data;
                this.foundCount = data.found || 0;
                this.notFoundCount = data.not_found || 0;
                this.duplicatesCount = data.duplicates || 0;
                this.processed = true;

                let message = `${data.found} transações encontradas, ${data.not_found} não encontradas`;
                if (data.duplicates > 0) {
                    message += `, ${data.duplicates} duplicadas`;
                }
                if (this.dryRun) {
                    message = `[SIMULAÇÃO] ${message}`;
                }
                this.toast.success(message);

                // Recarrega as notificações após o upload (se não for dry-run)
                if (!this.dryRun) {
                    this.loadNotifications();
                }
            } catch (error) {
                console.error(error);
                this.toast.error("Erro ao processar arquivo");
            } finally {
                this.uploading = false;
            }
        },

        async loadNotifications() {
            this.loadingNotifications = true;

            try {
                const params = {
                    page: this.notificationsPagination?.current_page || 1,
                };

                const { data } = await axios.get(
                    "/api/global-chargebacks/notifications",
                    { params },
                );

                this.notifications = data.data;
                // Ajusta a estrutura da paginação para o padrão do TableComponent
                this.notificationsPagination = {
                    total: data.total,
                    per_page: data.per_page,
                    current_page: data.current_page,
                    last_page: data.last_page,
                    from: data.from,
                    to: data.to,
                };
            } catch (error) {
                console.error("Erro ao carregar notificações:", error);
                this.toast.error("Erro ao carregar histórico de notificações");
            } finally {
                this.loadingNotifications = false;
            }
        },

        async processNotification(notification) {
            this.processingNotification = notification.id;

            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${notification.id}/process`,
                );

                this.toast.success("Notificação processada com sucesso");

                // Atualiza a notificação na lista local
                const index = this.notifications.findIndex(
                    (n) => n.id === notification.id,
                );
                if (index !== -1) {
                    this.notifications[index] = data.data;
                }
            } catch (error) {
                console.error("Erro ao processar notificação:", error);
                this.toast.error("Erro ao processar notificação");
            } finally {
                this.processingNotification = null;
            }
        },

        async viewCandidates(notification) {
            this.selectedNotification = notification;
            this.reviewMode = "view";
            await this.loadCandidates(notification);
            this.showReviewModal = true;
        },

        async reviewNotification(notification) {
            this.selectedNotification = notification;
            this.reviewMode = "review";
            await this.loadCandidates(notification);
            this.selectedTransactionId =
                this.candidatesData?.pre_selected_transaction_id || null;
            this.showReviewModal = true;
        },

        async loadCandidates(notification) {
            try {
                const { data } = await axios.get(
                    `/api/global-chargebacks/notifications/${notification.id}/candidates`,
                );
                this.candidatesData = data;
            } catch (error) {
                console.error("Erro ao carregar candidatos:", error);
                this.toast.error("Erro ao carregar candidatos");
            }
        },

        async confirmPreSelection() {
            this.reviewing = true;
            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${this.selectedNotification.id}/review`,
                    {
                        action: "confirm",
                    },
                );

                this.toast.success("Pré-seleção confirmada com sucesso!");
                this.updateNotificationInList(data.notification);
                this.closeModal();
            } catch (error) {
                console.error("Erro ao confirmar pré-seleção:", error);
                this.toast.error("Erro ao confirmar pré-seleção");
            } finally {
                this.reviewing = false;
            }
        },

        async changeSelection() {
            this.reviewing = true;
            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${this.selectedNotification.id}/review`,
                    {
                        action: "change",
                        transaction_id: this.selectedTransactionId,
                    },
                );

                this.toast.success("Associação alterada com sucesso!");
                this.updateNotificationInList(data.notification);
                this.closeModal();
            } catch (error) {
                console.error("Erro ao alterar associação:", error);
                this.toast.error("Erro ao alterar associação");
            } finally {
                this.reviewing = false;
            }
        },

        async rejectNotification() {
            this.reviewing = true;
            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${this.selectedNotification.id}/review`,
                    {
                        action: "reject",
                        reject_reason: this.rejectReason,
                    },
                );

                this.toast.success("Notificação rejeitada!");
                this.updateNotificationInList(data.notification);
                this.closeModal();
            } catch (error) {
                console.error("Erro ao rejeitar notificação:", error);
                this.toast.error("Erro ao rejeitar notificação");
            } finally {
                this.reviewing = false;
            }
        },

        updateNotificationInList(updatedNotification) {
            const index = this.notifications.findIndex(
                (n) => n.id === updatedNotification.id,
            );
            if (index !== -1) {
                // Adiciona os campos extras que são calculados no backend
                updatedNotification.order_id =
                    updatedNotification.transaction?.order_id;
                updatedNotification.transaction_status =
                    updatedNotification.transaction?.status;
                updatedNotification.requires_review =
                    updatedNotification.status === "pending_review";
                updatedNotification.candidate_count =
                    updatedNotification.potential_matches?.length || 0;
                updatedNotification.has_pre_selection =
                    updatedNotification.transaction_id !== null &&
                    !updatedNotification.association_confirmed;
                updatedNotification.is_confirmed =
                    updatedNotification.association_confirmed;

                this.notifications[index] = updatedNotification;
            }
        },

        async searchCandidates() {
            this.searchingCandidates = true;
            try {
                // Usa o novo endpoint específico para buscar candidatas
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${this.selectedNotification.id}/search-candidates`,
                );

                // Recarrega os dados de candidatos
                await this.loadCandidates(this.selectedNotification);

                // Atualiza a notificação na lista
                this.updateNotificationInList(data.notification);

                // Se encontrou candidatos e tem pré-seleção, já seleciona
                if (this.candidatesData?.pre_selected_transaction_id) {
                    this.selectedTransactionId =
                        this.candidatesData.pre_selected_transaction_id;
                }

                this.toast.success(
                    `Busca concluída! ${data.candidates_found} candidata${
                        data.candidates_found !== 1 ? "s" : ""
                    } encontrada${data.candidates_found !== 1 ? "s" : ""}.`,
                );
            } catch (error) {
                console.error("Erro ao buscar candidatas:", error);
                this.toast.error("Erro ao buscar candidatas");
            } finally {
                this.searchingCandidates = false;
            }
        },

        closeModal() {
            this.showReviewModal = false;
            this.selectedNotification = null;
            this.candidatesData = null;
            this.selectedTransactionId = null;
            this.showRejectReason = false;
            this.rejectReason = "";
            this.searchingCandidates = false;
        },

        isWithinTolerance(installmentValue, notificationAmount) {
            if (!installmentValue || !notificationAmount) return false;

            const tolerance = 0.5; // 50 centavos
            const diff = Math.abs(installmentValue - notificationAmount);

            return diff <= tolerance;
        },

        async forceSearch(notification) {
            this.processingNotification = notification.id;
            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${notification.id}/force-search`,
                );
                this.toast.success(
                    `Busca finalizada! ${data.candidates_found} candidata(s) encontrada(s).`,
                );
                this.updateNotificationInList(data.notification);
            } catch (error) {
                console.error("Erro ao forçar busca:", error);
                this.toast.error("Erro ao executar a busca.");
            } finally {
                this.processingNotification = null;
            }
        },

        async regenerateMatches(notification) {
            this.processingNotification = notification.id;
            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${notification.id}/regenerate-matches`,
                );
                this.toast.success(
                    `Lista de candidatos regenerada! ${data.candidates_count} candidata(s) com campos atualizados.`,
                );
                // Atualiza a notificação na lista
                const updatedNotification = notification;
                updatedNotification.potential_matches = data.matches;
                updatedNotification.candidate_count = data.candidates_count;
                this.updateNotificationInList(updatedNotification);
            } catch (error) {
                console.error("Erro ao regenerar matches:", error);
                this.toast.error("Erro ao regenerar lista de candidatos.");
            } finally {
                this.processingNotification = null;
            }
        },

        async clearMatches(notification) {
            if (
                !confirm("Tem certeza que deseja limpar a lista de candidatos?")
            ) {
                return;
            }

            this.processingNotification = notification.id;
            try {
                await axios.post(
                    `/api/global-chargebacks/notifications/${notification.id}/clear-matches`,
                );
                this.toast.success("Lista de candidatos limpa com sucesso!");
                // Atualiza a notificação na lista
                const updatedNotification = notification;
                updatedNotification.potential_matches = [];
                updatedNotification.candidate_count = 0;
                this.updateNotificationInList(updatedNotification);
            } catch (error) {
                console.error("Erro ao limpar matches:", error);
                this.toast.error("Erro ao limpar lista de candidatos.");
            } finally {
                this.processingNotification = null;
            }
        },

        async regenerateMatchesInModal() {
            this.regeneratingInModal = true;
            try {
                const { data } = await axios.post(
                    `/api/global-chargebacks/notifications/${this.selectedNotification.id}/regenerate-matches`,
                );
                this.toast.success(
                    `Lista de candidatos regenerada! ${data.candidates_count} candidata(s) com campos atualizados.`,
                );

                // Atualiza os dados do modal
                this.candidatesData.candidates = data.matches;

                // Atualiza a notificação na lista
                const updatedNotification = { ...this.selectedNotification };
                updatedNotification.potential_matches = data.matches;
                updatedNotification.candidate_count = data.candidates_count;
                this.updateNotificationInList(updatedNotification);
            } catch (error) {
                console.error("Erro ao regenerar matches no modal:", error);
                this.toast.error("Erro ao regenerar lista de candidatos.");
            } finally {
                this.regeneratingInModal = false;
            }
        },

        async clearMatchesInModal() {
            if (
                !confirm("Tem certeza que deseja limpar a lista de candidatos?")
            ) {
                return;
            }

            this.clearingInModal = true;
            try {
                await axios.post(
                    `/api/global-chargebacks/notifications/${this.selectedNotification.id}/clear-matches`,
                );
                this.toast.success("Lista de candidatos limpa com sucesso!");

                // Limpa os dados do modal e fecha
                this.candidatesData.candidates = [];

                // Atualiza a notificação na lista
                const updatedNotification = { ...this.selectedNotification };
                updatedNotification.potential_matches = [];
                updatedNotification.candidate_count = 0;
                this.updateNotificationInList(updatedNotification);

                // Fecha o modal já que não há mais candidatos
                this.closeModal();
            } catch (error) {
                console.error("Erro ao limpar matches no modal:", error);
                this.toast.error("Erro ao limpar lista de candidatos.");
            } finally {
                this.clearingInModal = false;
            }
        },

        async toggleNotificationExpansion(notification) {
            const notificationId = notification.id;

            if (this.expandedNotifications.has(notificationId)) {
                // Collapse
                this.expandedNotifications.delete(notificationId);
            } else {
                // Expand and load candidates if not cached
                if (!this.notificationCandidates.has(notificationId)) {
                    await this.loadCandidatesForNotification(notification);
                }
                this.expandedNotifications.add(notificationId);
            }

            // Force reactivity update
            this.expandedNotifications = new Set(this.expandedNotifications);
        },

        async loadCandidatesForNotification(notification) {
            const notificationId = notification.id;
            this.loadingCandidates.add(notificationId);
            this.loadingCandidates = new Set(this.loadingCandidates);

            try {
                const { data } = await axios.get(
                    `/api/global-chargebacks/notifications/${notificationId}/candidates`,
                );

                // Store in cache
                this.notificationCandidates.set(notificationId, data);
                this.notificationCandidates = new Map(
                    this.notificationCandidates,
                );
            } catch (error) {
                console.error("Erro ao carregar candidatos:", error);
                this.toast.error(
                    "Erro ao carregar candidatos para a notificação",
                );
            } finally {
                this.loadingCandidates.delete(notificationId);
                this.loadingCandidates = new Set(this.loadingCandidates);
            }
        },
    },
};
</script>
